const STORAGE_KEY = 'ibs_global_search_recent';
const MAX_RECENT = 15;
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function looksLikeRecordId(value) {
  const s = String(value || '').trim();
  if (!s) return true;
  return UUID_RE.test(s);
}

/** Prefer a human label; never surface a bare UUID as the recent title. */
export function displayRecentTitle(entry) {
  if (!entry) return 'Record';
  const title = String(entry.title || '').trim();
  if (title && !looksLikeRecordId(title)) return title;
  const label = String(entry.objectLabel || entry.objectName || 'Record').trim();
  return label ? `Untitled ${label}` : 'Untitled record';
}

export function readRecentlyViewed() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function pushRecentlyViewed({ id, objectName, objectLabel, title, href }) {
  if (!id || !objectName) return;
  const rawTitle = title != null ? String(title).trim() : '';
  const entry = {
    id: String(id),
    objectName: String(objectName),
    objectLabel: objectLabel || objectName,
    title: rawTitle && !looksLikeRecordId(rawTitle) ? rawTitle : '',
    href: href || `/view/${objectName}/${id}`,
    viewedAt: Date.now(),
  };
  const prev = readRecentlyViewed().filter(
    (item) => !(item.id === entry.id && item.objectName === entry.objectName)
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify([entry, ...prev].slice(0, MAX_RECENT)));
}

export function filterRecentlyViewed(allowedObjectNames) {
  const allow = new Set(
    (allowedObjectNames || []).map((n) => String(n).toLowerCase())
  );
  if (allow.size === 0) return [];
  return readRecentlyViewed().filter((item) =>
    allow.has(String(item.objectName).toLowerCase())
  );
}
